import * as actionTypes from './actionTypes';

export const addWithdraw=(withdraw)=>{
    return {
        type:actionTypes.ADD_WITHDRAW,
        payload:withdraw
    }
}